"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpointsDefault = void 0;
var breakpointsDefault = {
  s: 0,
  m: 320,
  l: 768,
  xl: 1280
};
exports.breakpointsDefault = breakpointsDefault;